import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Clock } from "@phosphor-icons/react";
import { api } from "@/api";
import { Button } from "@/components/ui/button";

export default function CheckoutSuccess({ clearCart }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "checking", order_status: "checking" });

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid") { clearCart(); return; }
        if (attempts < 6) setTimeout(poll, 2000);
      } catch { if (attempts < 6) setTimeout(poll, 2000); }
    };
    poll();
  }, [sessionId, clearCart]);

  const paid = status.payment_status === "paid";
  return (
    <main data-testid="checkout-success-page" className="grid min-h-[calc(100vh-74px)] place-items-center px-4 py-12">
      <section className="max-w-2xl border border-[#D5D1C4] bg-[#F1EFE7] p-8 text-center md:p-12">
        {paid ? <CheckCircle data-testid="payment-success-icon" size={50} className="mx-auto text-[#1A3626]" weight="duotone" /> : <Clock data-testid="payment-pending-icon" size={50} className="mx-auto text-[#C26B51]" weight="duotone" />}
        <h1 data-testid="payment-status-heading" className="mt-5 text-5xl font-light text-[#1A3626]">{paid ? "Payment confirmed" : "Checking payment"}</h1>
        <p data-testid="payment-status-message" className="mt-4 text-[#5C6A61]">{paid ? "Your bonsai order is now recorded in your order history." : "Stripe is confirming the session. This page will update automatically."}</p>
        <p data-testid="payment-session-id" className="mt-4 break-all text-xs text-[#5C6A61]">{sessionId}</p>
        <Button data-testid="view-orders-after-payment-button" asChild className="mt-8 rounded-none bg-[#1A3626]"><Link to="/orders">View orders</Link></Button>
      </section>
    </main>
  );
}